/* -------------------------------------------------------------------------- */
/*                                  Packages                                  */
/* -------------------------------------------------------------------------- */
import { navigate } from "gatsby"
import * as React from "react"

/* -------------------------------------------------------------------------- */
/*                             External Components                            */
/* -------------------------------------------------------------------------- */
import CookiePopup from "@components/global/CookiePopup"
import Modal from "@components/global/Modal"

/* -------------------------------------------------------------------------- */
/*                              Default Component                             */
/* -------------------------------------------------------------------------- */
export default function PreQualifyBanner(props) {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  return (
    <>
      <div className="bg-atlantic-blue-1 bottom-0 fixed [padding:17px_24px] min-tablet1:[padding-inline:48px] w-full min-desktop1:[padding-inline:54px] z-[100]">
        {/* Main Content */}
        <div className="flex flex-wrap gap-[32px] justify-between [margin-inline:auto] max-w-[1332px]">
          {/* Copy Container */}
          <div className="max-w-[516px]">
            {/* Heading */}
            <div className="bg-pacific-blue font-bold leading-[normal] [margin-block-end:4px] [padding:4px_8px] text-[25px] text-grey-1">
              Want to continue with your pre-approval?
            </div>
            <div className="caption font-variant-numeric--primary text-grey-5">
              You’ll be able to pick up right where you left off.
            </div>
          </div>
          {/* Cookie Selection Container */}
          <div className="[--gap:21px] flex flex-wrap gap-[var(--gap)] items-center">
            <div className="flex flex-wrap gap-[var(--gap)]">
              <button
                className="button button--tertiary"
                onClick={() => props.closeBanner()}
              >
                Not right now
              </button>
              <button
                onClick={() => {
                  props.closeBanner()
                  setTimeout(() => {
                    navigate(props.funnelPath)
                  }, 1000)
                }}
                className="button button--primary"
              >
                Yes, continue
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal closeModal={() => setIsModalOpen(false)} isModalOpen={isModalOpen}>
        <CookiePopup closeModal={() => setIsModalOpen(false)} />
      </Modal>
    </>
  )
}
